var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('address',[_vm._v(" "+_vm._s(_vm.person.address1)),_c('br'),(_vm.person.address2)?_c('span',[_vm._v(_vm._s(_vm.person.address2)),_c('br')]):_vm._e(),_vm._v(" "+_vm._s(_vm.person.postcode)+" "+_vm._s(_vm.person.town)+" "),_c('CopyButton',{attrs:{"value":_vm.value}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }